// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"b3201c10","233":"2ad08108","973":"b3201c10","991":"90454421"}[chunkId] + ".chunk.css";
};